import React from "react"
import TlkTable from "../tlelrik/table/tlkTable"
import services from "../../services"
import queryString from "query-string"
import ContaTabs from "./ContaTabs"
import { Button } from "@progress/kendo-react-buttons"
import { Input } from "@progress/kendo-react-inputs"
import { DatePicker } from "@progress/kendo-react-dateinputs"
import { toast } from "react-toastify"
import { Select } from 'antd';
import $ from 'jquery';

var moment = require("moment")
const dateFormat = "YYYY-MM-DD"
const dateShowFormat = "dd/MM/yyyy"
const { Option } = Select

// TODO: Rewrite component as per the movement listing in invision
// Ask @Dart for the same
const columnKeyMap = {
  // 'Movimento': 'Movimento',
  dataCriado: "Data de criação",
  numeroDocumento: "Num Documento",
  descricao: "Descrição",
  "Valor da Operação": "Valor da Operação",
  "Saldo Atual": "Saldo Atual",
  //saldoCativo: "Saldo Cativo",
  tipoMovimento: "Tipo de Movimento",
  "Detalhes do movimento": "Detalhes do movimento",
}

class AccountMovement extends React.Component {
  constructor() {
    super()

    this.state = {
      isMovementSelected: false,
      needEntidade: false,
      needTipoContaDestino: false,
      lotas: false,
      desclassificacao: false,
      destilacao: false,
      constituicaoLotes: false,
      certProcedencia: false,
      isDestilador: 0,
      movements: [],
      movementsType: [],
      estatuto: [],
      entidades: [],
      tiposConta: [],
      lotasProdutoDestino: [],
      destilacaoProdutoDestino: [],
      lotasContasDestino: [],
      constLotesContasDestino: [],
      descProdutoDestino: [],
      descMencoesComp: [],
      certProcLocalArmaz: [],
      certProcSelosSeg: [],
      certProcIVDest: [],
      loaded: false,
      data: [],
      entityDetail: {},
      columnList: [],
      selectedMovemment: [],
      accountTotal: 0,
      filters: {
        Filters: { entityId: null },
        FiltersIn: null,
        FiltersLike: null,
        SortBy: "",
        IsSortTypeDESC: true,
        IsPagination: false,
        Page: 2,
        PageSize: 2,
      },
      filtersEnt: {
        Filters: { entityId: null },
        FiltersIn: null,
        FiltersLike: null,
        SortBy: "",
        IsSortTypeDESC: false,
        IsPagination: true,
        Page: 2,
        PageSize: 20,
      },
      filtersTpConta: {
        Filters: { tipoContaId: null },
        FiltersIn: null,
        FiltersLike: null,
        SortBy: "",
        IsSortTypeDESC: false,
        IsPagination: true,
        Page: 2,
        PageSize: 20,
      },
      operation: {
        // IDMovimento: null,
        // IDEstatuto: null,
        // IDTipoConta: null,
        // IDProduto: null,
        // IDContaCorrente: null,
        // IDTipoMovimento: null,
        // IDTipoOperacao: null,
        Descricao: "",
        DataOperacao: new Date(),
        ValorOperacao: 0,
        NumeroDocumento: "",
        IDTipoFormulario: null,
        TipoFormulario: "",
        IDEntidadeDestino: null,
        IDTipoContaDestino: null,
        IDContaCorrenteDestino: null,
        ManterAno: false,
        ManterMencoes: [],
        //ManterGarrafeira: [],
        IDProdutoDestino: null,
        NumeroEDA: "",
        IDInstalacaoVinicaDestino: null,
        IDSelosSeguranca: [],
        Lote: "",
        //ExpMorada: "",
        ExpMatricula: "",
        DataCarregamento: new Date()
        // fileObj : []
      },
    }
  }

  componentDidMount() {
    let estatuto = []
    let entidades = []
    
    ;(async () => {
      const queryParams = queryString.parse(this.props.location.search)
      const filters = {
        ...this.state.filters,
        Filters: queryParams,
      }
      let accountTotal = queryParams.sa || "0"
      accountTotal = accountTotal.split(",")[0]
      accountTotal = accountTotal.replace(".", "")
      console.log("8899 total", accountTotal)
      this.setState({
        accountTotal,
      })
      console.log("accont Movements worked... ", filters)
      const response = await services.apiCall.requestApi(
        "ContaCorrente/GetContasCorrentes",
        filters,
        "post"
      )

      if (response) {
        const columnList = Object.keys(columnKeyMap).map((key) => ({
          field: columnKeyMap[key],
          columnMenuType: "checkbox",
        }))
        const data = response.map((entity) => ({
          ...Object.keys(columnKeyMap).reduce((acc, key) => {
            acc[columnKeyMap[key]] = entity[key]
            if (key === "dataCriado") {
              acc[columnKeyMap[key]] = entity["dataCriado"]
                ? moment(entity["dataCriado"]).format(dateFormat)
                : "nd"
            }
            return acc
          }, {}),
          selected: false,
        }))
        this.setState(() => ({ data, columnList, loaded: true }))
      }
    })()
    ;(async () => {
      estatuto = await services.apiCall.requestApi(
        "SIVDP/Estatutoes/GetAll",
        this.state.filters,
        "post"
      )
      this.setState({ estatuto })
    })()
    ;(async () => {
      entidades = await services.apiCall.requestApi(
        "allservice/Entidades/GetAll",
        this.state.filtersEnt,
        "post"
      )
      this.setState({ entidades })
    })()
    
    ;(async () => {
      const queryParam = queryString.parse(this.props.location.search)
      console.log("query params 888", queryParam)
      let Filters = {
        entityId: queryParam.entityId,
        accountId: queryParam.accountId,
      }
      const filter = {
        ...this.state.filters,
        Filters,
      }
      const movements = await services.apiCall.requestApi(
        "SIVDP/Movimento/GetMovementbyTipoEstatuto",
        filter,
        "post"
      )
      this.setState({ movements: movements })
      console.log(
        "🚀 ~ file: Nivel1.js ~ line 83 ~ Nivel1Form ~ movements",
        movements
      )
    })()
  }

  getToolbarHtml() {
    const params = queryString.parse(this.props.location.search)
    return (
      <>
        <span className="pr-3">Nº Conta Corrente: {params.ncc || "nd"}</span>
        <span className="px-3 border-left">
          Tipo de Conta: {params.tpc || "nd"}
        </span>
        <span className="px-3 border-left">Produto: {params.pr || "nd"}</span>
        <span className="px-3 border-left">
          Saldo Atual: {params.sa || "nd"}
        </span>
      </>
    )
  }
  
  handleDate = (e) => {
    const { operation } = this.state
    operation.DataOperacao = moment(e.value).format(dateFormat)
    this.setState({ operation })
  }

  handleDateCarregamento = (e) => {
    const { operation } = this.state
    operation.DataCarregamento = moment(e.value).format(dateFormat)
    this.setState({ operation })
  }
  
  handleDatePicker = () => {
    let datePicker = ""

    datePicker = (
      <DatePicker
        className="form-control deadlineclender input-1"
        size="middle"
        label="Data da Operação"
        placeholder="Data Atual"
        format={dateShowFormat}
        onChange={this.handleDate}
      />
    )
    // let data = { ...this.state.data }
    // let date = "";
    // if (data && data.parcel) {
    //   date = data.parcel.dtultvist;
    //   if (date) {
    // date = moment(date).format(dateShowFormat);

    datePicker = (
      <div>
        <span className="deadlineclenderlable">Data da operação</span>
        <DatePicker
          className="form-control deadlineclender input-1"
          size="middle"
          placeholder="Data última vistoria"
          label="Data da operação"
          value={new Date(this.state.operation.DataOperacao)} //moment(, dateFormat)}
          format={dateShowFormat}
          //   readOnly={this.props.isEnable("dtultvist")}
          onChange={this.handleDate}
        />
      </div>
    )
    //   }
    // }
    return datePicker
  }

  handleDatePickerExpedicao = () => {
    let datePicker = ""

    datePicker = (
      <DatePicker
        className="form-control deadlineclender input-1"
        size="middle"
        label="Data e Hora do Carregamento"
        placeholder="Data Atual"
        format={dateShowFormat}
        onChange={this.handleDateCarregamento}
      />
    )
    // let data = { ...this.state.data }
    // let date = "";
    // if (data && data.parcel) {
    //   date = data.parcel.dtultvist;
    //   if (date) {
    // date = moment(date).format(dateShowFormat);

    datePicker = (
      <div>
        <span className="deadlineclenderlable">Data e Hora do Carregamento</span>
        <DatePicker
          className="form-control deadlineclender input-1"
          size="middle"
          label="Data e Hora do Carregamento"
          value={new Date(this.state.operation.DataCarregamento)} //moment(, dateFormat)}
          format={dateShowFormat}
          //   readOnly={this.props.isEnable("dtultvist")}
          onChange={this.handleDateCarregamento}
        />
      </div>
    )
    //   }
    // }
    return datePicker
  }

  handleCancel = () => {
    // this.props.history.push({
    //   pathname : "/conta_corrente"
    // })
    window.history.back()
  }

  handleChangeFormulario = async (e) => {
    this.setState({ selectedMovemment: [], isMovementSelected: false, needTipoContaDestino: false, needEntidade: false, lotasProdutoDestino: false })
    let { operation, selectedMovemment } = this.state
    let tiposConta = []
    let lotasProdutoDestino = []
    let descProdutoDestino = []
    let descMencoesComp = []
    let descGarrafeira = []
    let ManterMencoes = []
    //let ManterGarrafeira = []
    let destilacaoProdutoDestino = []
    let constLotesContasDestino = []
    let certProcLocalArmaz = []
    let certProcSelosSeg = []

    if (e.target.type === "select-one") {
      //operation[e.target.name] = Number(e.target.value)

      var ID = e.target.value;
      var IDTipoFormularioSelected = 0;
      
      this.state.movements.forEach(x => {
        if(x.idTipoFormulario == ID){
          IDTipoFormularioSelected = ID;
          operation[e.target.name] = Number(e.target.value)
        }
      });

      //call API
      (async () => {

        const filter = {
          IDTipoFormulario: IDTipoFormularioSelected
        }
        console.log("FILTROS");
        console.log(filter);
        const movementsType = await services.apiCall.requestApi(
          "RegrasMovimento/ViewTipoFormularioTipoMovimento",
          filter,
          "get"
        )
        
        this.setState({ movementsType: movementsType })

        if (movementsType != undefined && movementsType.length == 1){
          var ID = $("select[name=IDTipoMovimento]")[0].value;

          this.state.movementsType.forEach(x => {
            console.log(x.idTipoMovimento);
            console.log(ID);
            if(x.idTipoMovimento == ID){
              selectedMovemment[0] = x;
            }
          });
          // Transf Entre Contas
          if (this.state.movementsType[0].idTipoFormulario == 5){
            this.setState({ selectedMovemment, isMovementSelected: true, needTipoContaDestino: true })
            const queryParam = queryString.parse(this.props.location.search);

            ;(async () => {
              const filters = { 
                IDTipoFormulario: +this.state.movementsType[0].idTipoFormulario,
                IDProduto: queryParam.idp,
                IDTipoConta: queryParam.idTC
              };
              tiposConta = await services.apiCall.requestApi("RegrasMovimento/GetTipoContaDestino", filters, 'get');
              this.setState({ tiposConta })
            })()
          }
          // Cedências + Transf dentro do Local Armazenagem
          else if (this.state.movementsType[0].idTipoFormulario == 3 || this.state.movementsType[0].idTipoFormulario == 4){
            this.setState({ selectedMovemment, isMovementSelected: true, needEntidade: true })
          }
          // Lotas
          else if (this.state.movementsType[0].idTipoFormulario == 7){
            this.setState({ selectedMovemment, isMovementSelected: true, lotas: true })
            const queryParam = queryString.parse(this.props.location.search);
            
            ;(async () => {
              const filters = { 
                IDTipoFormulario: +this.state.movementsType[0].idTipoFormulario,
                IDProduto: +queryParam.idp
              };
              lotasProdutoDestino = await services.apiCall.requestApi("ContaCorrente/GetProdutosDestino", filters, 'get');
              this.setState({ lotasProdutoDestino })
            })()
 
          }
          // Desclassificação
          else if (this.state.movementsType[0].idTipoFormulario == 8){
            this.setState({ selectedMovemment, isMovementSelected: true, desclassificacao: true })
            const queryParam = queryString.parse(this.props.location.search);
            
            ;(async () => {
              const filters = { 
                IDTipoFormulario: +this.state.movementsType[0].idTipoFormulario,
                IDProduto: +queryParam.idp
              };
              descProdutoDestino = await services.apiCall.requestApi("ContaCorrente/GetProdutosDestino", filters, 'get');
              this.setState({ descProdutoDestino })
            })()

            ;(async () => {
              const filters = { 
                IDContaCorrente: +queryParam.accountId
              };
              descMencoesComp = await services.apiCall.requestApi("ContaCorrente/GetMencoesComplementares", filters, 'get');
              console.log("mencoes: ", descMencoesComp)
              if(descMencoesComp != undefined){
              if (descMencoesComp.mencoesCasta.length > 0){
                descMencoesComp.mencoesCasta.forEach(element => {
                  var obj = { IDContaCorrenteMencaoComplementar: element.idContaCorrenteMencaoComplementar, Manter: false}
                  ManterMencoes.push(obj)
                });
              }
              if (descMencoesComp.mencoesQuinta.length > 0){
                descMencoesComp.mencoesQuinta.forEach(element => {
                  var obj = { IDContaCorrenteMencaoComplementar: element.idContaCorrenteMencaoComplementar, Manter: false}
                  ManterMencoes.push(obj)
                });
              }
              if (descMencoesComp.outrasMencoes.length > 0){
                descMencoesComp.outrasMencoes.forEach(element => {
                  var obj = { IDContaCorrenteMencaoComplementar: element.idContaCorrenteMencaoComplementar, Manter: false}
                  ManterMencoes.push(obj)
                });
              }
            
              this.setState({ descMencoesComp, operation: {...this.state.operation, "ManterMencoes": ManterMencoes } })}
            })()
            ;(async () => {
              var ManterAnoCheck = $("#desc-manter-ano").prop("checked");
              const filters = { 
                IDContaCorrente: +queryParam.accountId,
                ManterAno: ManterAnoCheck
              };
              descGarrafeira = await services.apiCall.requestApi("ContaCorrente/ValidateProdutoGarrafeira", filters, 'get');
              if(descGarrafeira != undefined){
                
                    var obj = { IDContaCorrenteMencaoComplementar: descGarrafeira.idContaCorrenteMencaoComplementar, Manter: false}
                    ManterMencoes.push(obj)
              
                
              }
              this.setState({ descGarrafeira, operation: {...this.state.operation, "ManterMencoes": ManterMencoes  }})
            })()
          }
          // Destilação
          else if (this.state.movementsType[0].idTipoFormulario == 11){
            this.setState({ selectedMovemment, isMovementSelected: true, destilacao: true })
            const queryParam = queryString.parse(this.props.location.search);
            
            ;(async () => {
              const filters = { 
                IDTipoFormulario: +this.state.movementsType[0].idTipoFormulario,
                IDProduto: +queryParam.idp
              };
              destilacaoProdutoDestino = await services.apiCall.requestApi("ContaCorrente/GetProdutosDestino", filters, 'get');
              this.setState({ destilacaoProdutoDestino })
            })()

          }
          // Constituição de Lotes
          else if (this.state.movementsType[0].idTipoFormulario == 9){
            this.setState({ selectedMovemment, isMovementSelected: true, constituicaoLotes: true })
            const queryParam = queryString.parse(this.props.location.search);
            
            ;(async () => {
              const filters = { 
                IDEntidade: +queryParam.entityId,
                IDInstalacaoVinica: +queryParam.IDInstalacaoVinica,
                AnoProduto: +queryParam.ano,
                IDCor: +queryParam.idCor,
                IDProduto: +queryParam.idp,
                IDContaCorrenteOrigem: +queryParam.accountId,
                IDTipoContaOrigem: +queryParam.idTC
              };
              constLotesContasDestino = await services.apiCall.requestApi("ContaCorrente/GetContasConstituicaoLotes", filters, 'get');
              this.setState({ constLotesContasDestino })
            })()

          }
          // Certificados de Procedência
          else if (this.state.movementsType[0].idTipoFormulario == 10){
            this.setState({ selectedMovemment, isMovementSelected: true, certProcedencia: true })
            const queryParam = queryString.parse(this.props.location.search);
            
            ;(async () => {
              const filters = { 
                IDEntidade: +queryParam.entityId,
                IDContaCorrente: +queryParam.accountId
              };
              certProcLocalArmaz = await services.apiCall.requestApi("InstalacaoVinica/ViewLocalArmazenagem", filters, 'get');
              this.setState({ certProcLocalArmaz })
            })()

            ;(async () => {
              const filters = { 
                IDEntidade: +queryParam.entityId
              };
              certProcSelosSeg = await services.apiCall.requestApi("Fiscalizacao/GetSelosSegurancaEntidade", filters, 'get');
              this.setState({ certProcSelosSeg })
            })()

            ;(async () => {
              const filters = { 
                IDEntidade: +queryParam.entityId
              };
              var isDestilador = await services.apiCall.requestApi("Entidades/ValidateDestilador", filters, 'get');
              console.log(isDestilador)
              console.log(+queryParam.idp)
              if(isDestilador == 1){
                $("#selos-seguranca").addClass("d-none");
              }
              else{
                $("#selos-seguranca").removeClass("d-none");
              }
              if (+queryParam.idp == 84 || +queryParam.idp == 86 || +queryParam.idp == 109 || +queryParam.idp == 110){
                $("#certNif").removeClass("d-none");
                
                if (isDestilador == 1){
                 $("#certNif").removeClass("d-none");
                }
                else{
                  $("#selos-seguranca").removeClass("d-none");
                  $("#certNif").addClass("d-none");
                }
              }

              this.setState({ isDestilador })
            })()

          }
          else{
            this.setState({ selectedMovemment, isMovementSelected: true, needTipoContaDestino: false, lotas: false, desclassificacao: false, destilacao: false, constituicaoLotes: false, certProcedencia: false })
          }

        } 
           
      })()

      // this.setState({
      //   ...operation,
      //   selectedMovemment,
      //   isMovementSelected: true,
      // })
    } else {
      operation[e.target.name] = e.target.value
      this.setState({ operation })
    }
  }

  handleChange = async (e) => {
    let { operation, selectedMovemment } = this.state

    if (e.target.type === "select-one") {
      operation[e.target.name] = Number(e.target.value)

      var ID = e.target.value;
      
      this.state.movementsType.forEach(x => {
        console.log(x.idTipoMovimento);
        console.log(ID);
        if(x.idTipoMovimento == ID){
          selectedMovemment[0] = x;
        }
      });

      var needEnt = false;
      if (this.state.operation.IDTipoFormulario == 2 || this.state.operation.IDTipoFormulario == 3 || this.state.operation.IDTipoFormulario == 4){
        needEnt = true;
      }

      // selectedMovemment = this.state.movements.filter(
      //   (movement) => movement.idTipoFormulario === e.target.value
      // )
      this.setState({
        ...operation,
        selectedMovemment,
        isMovementSelected: true,
        needEntidade: needEnt
      })
    } else {
      operation[e.target.name] = e.target.value
      this.setState({ operation })
    }
  }
  
  handleChangeEntidade = (e) => {
    this.setState({ operation: {...this.state.operation, "IDEntidadeDestino": e } });
  }

  handleChangeTipoContaDestino = (e) => {
    this.setState({ operation: {...this.state.operation, "IDTipoContaDestino": e } });
  }

  handleChangeProdutoDestinoLotas = (e) => {
    let lotasContasDestino = [];
    const queryParam = queryString.parse(this.props.location.search);

    (async () => {
      ;(async () => {
        const filters = { 
          IDTipoFormulario: +this.state.movementsType[0].idTipoFormulario,
          IDProduto: e,
          IDEntidade: +queryParam.entityId,
          IDInstalacaoVinica: +queryParam.IDInstalacaoVinica
        };
        lotasContasDestino = await services.apiCall.requestApi("ContaCorrente/GetContasDestinoLotas", filters, 'get');
        this.setState({ lotasContasDestino })
      })()
    })()
     
  }

  handleChangeProdutoDestinoDestilacao = (e) => {
    let instalacaoVinica;
    const queryParam = queryString.parse(this.props.location.search);

    (async () => {
      ;(async () => {
        const filters = { 
          IDInstalacaoVinica: +queryParam.IDInstalacaoVinica
        };
        instalacaoVinica = await services.apiCall.requestApi("InstalacaoVinica/ViewInstalacaoVinicaDetalhe", filters, 'get');

        if (e === 128){
          if (instalacaoVinica.codEntrFiscal != null){
            $("#NumEDADiv").removeClass("d-none");
            this.setState({ operation: {...this.state.operation, "IDProdutoDestino": e } })
          }
          else{
            $("#NumEDADiv").addClass("d-none");
            this.setState({ operation: {...this.state.operation, "IDProdutoDestino": e, "NumeroEDA": "" } })

          }
        }
        else{
          $("#NumEDADiv").addClass("d-none");
          this.setState({ operation: {...this.state.operation, "IDProdutoDestino": e, "NumeroEDA": "" } })

        }
        
      })()
    })()

  }

  handleChangeLocalArmazCertProc = (e) => {
    let certProcIVDest = [];
    const queryParam = queryString.parse(this.props.location.search);
    
    (async () => {
      ;(async () => {
        const filters = { 
          codEntidade: +queryParam.entityId,
          idLocalArmazenagem: e
        };
        certProcIVDest = await services.apiCall.requestApi("InstalacaoVinica/ViewInstalacoesVinicasEntidade", filters, 'get');
        this.setState({ certProcIVDest })
      })()
    })()
     
  }

  handleChangeIVDest = (e) => {
    this.setState({ operation: {...this.state.operation, "IDInstalacaoVinicaDestino": e } })
  }

  handleChangeCertProcSelosSeg = (e) => {
    console.log("selos", e)
    this.setState({ operation: {...this.state.operation, "IDSelosSeguranca": e } })
  }

  handleChangeProdutoDestinoDesc = (e) => {
    this.setState({ operation: {...this.state.operation, "IDProdutoDestino": e } })
  }

  handleChangeContaDestino = (e) => {
    this.setState({ operation: {...this.state.operation, "IDContaCorrenteDestino": e } });
  }

  handleChangeManterAno = (value) => {
    let descGarrafeira = [];
    let ManterGarrafeira = [];
    const queryParam = queryString.parse(this.props.location.search);
    this.setState({ operation: {...this.state.operation, "ManterAno": value } });
    (async () => {
      var ManterAnoCheck = $("#desc-manter-ano").prop("checked");
      const filters = { 
        IDContaCorrente: +queryParam.accountId,
        ManterAno: ManterAnoCheck
      };
      descGarrafeira = await services.apiCall.requestApi("ContaCorrente/ValidateProdutoGarrafeira", filters, 'get');
      if(descGarrafeira != undefined){
        if (descGarrafeira.length > 0){
          descGarrafeira.forEach(element => {
            var obj = { IDContaCorrenteMencaoComplementar: element.idContaCorrenteMencaoComplementar, Manter: false}
            ManterGarrafeira.push(obj)
          });
        }
      }
      this.setState({ descGarrafeira, operation: {...this.state.operation, "ManterGarrafeira": ManterGarrafeira  }})
    })()
  }

  handleChangeMencoes = (checked, id) => {
    let ManterMencoes = this.state.operation.ManterMencoes;

    var objIndex = ManterMencoes.findIndex((obj => obj.IDContaCorrenteMencaoComplementar == id));
    ManterMencoes[objIndex].Manter = checked

    this.setState({ operation: {...this.state.operation, "ManterMencoes": ManterMencoes } });
  }
  handleChangeGarrafeira = (checked, id) => {
    let ManterMencoes = this.state.operation.ManterMencoes;

    var objIndex = ManterMencoes.findIndex((obj => obj.IDContaCorrenteMencaoComplementar == id));
    ManterMencoes[objIndex].Manter = checked

    this.setState({ operation: {...this.state.operation, "ManterMencoes": ManterMencoes } });
  }
  // handleChangeGarrafeira = (value) => {
  
  //   this.setState({ operation: {...this.state.operation, "ManterMencoes": value } });
  // }
  handleChangeNumEDA = (e) => {
    this.setState({ operation: {...this.state.operation, "NumeroEDA": e.value } });
  }

  handleChangeLoteCertProc = (e) => {
    this.setState({ operation: {...this.state.operation, "Lote": e.value } });
  }

  // handleChangeMoradaCertProc = (e) => {
  //   this.setState({ operation: {...this.state.operation, "ExpMorada": e.value } });
  // }

  handleChangeMatriculaCertProc = (e) => {
    this.setState({ operation: {...this.state.operation, "ExpMatricula": e.value } });
  }

  handleSubmit = async (e) => {
    e.preventDefault()
    //let error = null
    let errors = {}
    // let formData = new FormData();
    let operation = { ...this.state.operation }
    
    for (let key in operation) {
      switch (key) {
        // case "Descricao":
        //   if (!operation[key]) {
        //     errors.Descricao = {
        //       Descricao: ["campo obrigatório"],
        //     }
        //   }
        //   break;
        case "DataOperacao":
          if (!operation[key]) {
            errors.DataOperacao = {
              DataOperacao: ["campo obrigatório"],
            }
            operation[key] = moment(operation[key]).format(dateFormat)
          }
          break;
        case "ValorOperacao":
          if (!operation[key]) {
            errors.ValorOperacao = {
              ValorOperacao: ["campo obrigatório"],
            }
            // }else if(!isNaN(operation[key])){
            //   errors.ValorOperacao = {
            //   "ValorOperacao": ["O valor da operação deve ser um número"]
            //  }
          }
          break;
        // case "IDEntidadeDestino":
        //   if (!operation[key]) {
        //     errors.IDEntidadeDestino = {
        //       IDEntidadeDestino: ["campo obrigatório"],
        //     }
        //   }
        //   break;
        default:
          break;
      }
    }
    if (Object.keys(errors).length > 0) {
    //   error = {
    //     errors: errors,
    //   }
    //   services.errorCheck.error(error)
      this.setState({
        mandatoryFieldsMissing: true
      })
      return
    }

    if (operation["DataOperacao"]) {
      operation["DataOperacao"] = moment(operation["DataOperacao"]).format(
        dateFormat
      )
    }

    // Object.keys(operation).map(_k => {
    //   if(_k === 'fileObj'){
    //     for (let i = 0; i < operation['fileObj'].length; i++) {
    //       formData.append(`fileObj`, operation['fileObj'][i])
    //     }
    //   }else{
    //     formData.append(_k,operation[_k])
    //   }
    // })

    if (Object.keys(errors).length == 0) {
      ;(async () => {
        // const query = queryString.parse(this.props.location.search)
        // operation = {
        //   ...operation,
        //   IDMovimento: this.state.selectedMovemment[0].idMovimento,
        //   IDEstatuto: +query.idEst,
        //   IDTipoConta: +query.idTC,
        //   IDProduto: null,
        //   IDContaCorrente: +query.accountId,
        //   IDTipoMovimento:
        //     (this.state.selectedMovemment &&
        //       this.state.selectedMovemment[0].idTipoMovimento) ||
        //     null,
        //   IDTipoOperacao: null,
        //   idEntidade: +query.entityId,
        // }
        
        const query = queryString.parse(this.props.location.search);

        // Validar se tem pelo menos 1 instalação vínica
        let validarIDEntidade = this.state.operation.IDEntidadeDestino;

        if (this.state.operation.IDEntidadeDestino == null){
          validarIDEntidade = +query.entityId;
        }

        const filter = {
          CodEntidade: +validarIDEntidade
        }
        const instalacoesVinicasDestino = await services.apiCall.requestApi(
          "InstalacaoVinica/ViewInstalacoesVinicasEntidade",
          filter,
          "get"
        )
        if (instalacoesVinicasDestino == undefined){
          toast.error("A entidade de destino não possui nenhuma instalação vínica.")
          return;
        }

        var entDestino = +this.state.operation.IDEntidadeDestino;

        if (this.state.movementsType[0].idTipoFormulario == 10 && (entDestino == null || entDestino == 0)){
          entDestino = +query.entityId;
        }

        const params = {
          IDContaCorrente: +query.accountId,
          IDTipoFormulario: +this.state.movementsType[0].idTipoFormulario,
          IDTipoMovimento: +this.state.selectedMovemment[0].idTipoMovimento,
          Quantidade: +this.state.operation.ValorOperacao,
          LoggedUser: window.localStorage.getItem('username'),
          Observacoes: this.state.operation.Descricao,
          IDEntidadeDestino: entDestino,
          IDTipoContaDestino: +this.state.operation.IDTipoContaDestino,
          IDContaCorrenteDestino: +this.state.operation.IDContaCorrenteDestino,
          ManterAno: this.state.operation.ManterAno,
          ManterMencoes: this.state.operation.ManterMencoes,
          //ManterGarrafeira: this.state.operation.ManterGarrafeira,
          IDProdutoDestino: +this.state.operation.IDProdutoDestino,
          NumeroEDA: this.state.operation.NumeroEDA,
          IDInstalacaoVinicaOrigem: +query.IDInstalacaoVinica,
          IDInstalacaoVinicaDestino: +this.state.operation.IDInstalacaoVinicaDestino,
          IDEntidadeOrigem: +query.entityId,
          IDSelosSeguranca: this.state.operation.IDSelosSeguranca,
          Lote: this.state.operation.Lote,
          ExpMatricula: this.state.operation.ExpMatricula,
          //ExpMorada: this.state.operation.ExpMorada,
          DataCarregamento: this.state.operation.DataCarregamento
        }

        console.log("SEND PARAMS");
        console.log(params);

        /*if (!operation.IDTipoMovimento) {
          toast.error("o movimento selecionado não tem um tipo de movimento")
          return
        }*/

        if(+operation.ValorOperacao > +this.state.accountTotal) {
          toast.error("Saldo insuficiente para este movimento")
          return
        }

        const response = await services.apiCall.requestApi(
          //"ContaCorrente/ExecutarMovimento?IDContaCorrente="+query.accountId+"&IDTipoFormulario="+this.state.movementsType[0].idTipoFormulario+"&IDTipoMovimento="+this.state.selectedMovemment[0].idTipoMovimento+"&Quantidade="+this.state.operation.ValorOperacao+"&LoggedUser="+window.localStorage.getItem('username')+"&Observacoes="+this.state.operation.Descricao+"&IDEntidadeDestino="+this.state.operation.IDEntidadeDestino,
          "ContaCorrente/ExecutarMovimento",
          params,
          "post"
        )
        console.log("response", response);
        if (response) {
          
          this.handleCancel()
        }
      })()
    }
  }

  entityDetailData = (data) => {
    this.setState({ entityDetail: data })
  }

  accountDetailsToPass = () => {
    const params = queryString.parse(this.props.location.search)
    console.log("params9999 ", params)
    let accountDetails = {}
    accountDetails["accountNumber"] = params.ncc || "NA"
    accountDetails["accounttype"] = params.tdc || "NA"
    accountDetails["accountProduct"] = params.pr || "NA"
    accountDetails["saldoGranel"] = params.sldG || "NA"
    accountDetails["saldoApto"] = params.sldA || "NA"
    accountDetails["saldoEngarrafado"] = params.sldE || "NA"
    accountDetails["accountTotal"] = params.sa || "NA"
    accountDetails["tipoConta"] = params.tpc || "NA"
    return accountDetails
  }

  searchEntidade = (e) => {
    console.log("hey");
    console.log(e);
    let entidades = []
    
    if (e == ""){
      return;
    }

    const filters = {
      ...this.state.filtersEnt,
      Filters: {
          ...this.state.filtersEnt.Filters,
          entityName: e
      },
    };

    ;(async () => {
      entidades = await services.apiCall.requestApi(
        "allservice/Entidades/GetAll",
        filters,
        "post"
      )
      this.setState({ entidades })
    })()
  }

  render() {
    //const toolBar = this.getToolbarHtml();
    let { operation } = this.state
    //const param = queryString.parse(this.props.location.search)

    return (
      <>
        <div className="mt-4">
          <ContaTabs
            screen="movements"
            accountDetails={this.accountDetailsToPass()}
            entityDetailData={(data) => this.entityDetailData(data)}
            search={this.props.location.search}
          />
          {/* <div className="text-right">
            <Button className="mr-2 btn-ivdp-primary btn-theme k-primary" onClick={ () => window.history.back() }>Voltar</Button>
          </div> */}
          <div className="table-section custom-k-grid pt-3">
            <div>
              {/* <form onSubmit={this.handleSubmit}> */}
              {this.state.loaded && (
                // <div className="k-widget k-grid tlkTableSize" role="grid">
                <>
                  {/* <span className="pr-3">Entidade : {entityDetail.busEntidade && entityDetail.busEntidade.nome}</span>
                    <span className="px-3 border-left">Instalação Vinic Associada: {entityDetail && entityDetail.wineInhalation ? entityDetail.wineInhalation : 'nd' }</span>
                    <div className="k-header k-grid-toolbar">
                        <span className="d-inline-block toolbar-text">{toolBar}</span>
                    </div> */}
                  <div className="row mt_20">
                    <div className="col-md-6">
                      <div className="input-box active-grey drop-down-box">
                        <label className="input-label">
                          Fluxo vínico a executar
                        </label>
                        <select
                          defaultValue={"default"}
                          className="custome-drop-down"
                          value={this.state.operation.idTipoFormulario}
                          onChange={(e) => this.handleChangeFormulario(e)}
                          name="IDTipoFormulario"
                        >
                          <option disabled value="default">
                            Selecione o fluxo vínico{" "}
                          </option>
                          {this.state.movements &&
                            this.state.movements.length > 0 &&
                            this.state.movements.map((_row, _indx) => {
                              return (
                                <option key={_indx} value={_row.idTipoFormulario}>
                                  {_row.tipoFormulario}
                                </option>
                              )
                            })}
                        </select>
                      </div>
                    </div>
                    {this.state.movementsType &&
                      this.state.movementsType.length > 0 &&
                      <>
                      <div className="col-md-6">
                        <div className="input-box active-grey drop-down-box">
                          <label className="input-label" id="inp-lbl-mov">
                            Movimento a Executar
                          </label>
                          {this.state.movementsType &&
                            this.state.movementsType.length != 1 &&
                            <>
                            <select
                              defaultValue={"default"}
                              className="custome-drop-down"
                              value={this.state.operation.idTipoMovimento}
                              onChange={(e) => this.handleChange(e)}
                              name="IDTipoMovimento"
                            >
                              <option disabled value="default">
                                Selecione o movimento{" "}
                              </option>
                              {this.state.movementsType &&
                                this.state.movementsType.length > 0 &&
                                this.state.movementsType.map((_row, _indx) => {
                                  return (
                                    <option key={_indx} value={_row.idTipoMovimento}>
                                      {_row.codTipoMovimento} - {_row.tipoMovimento}
                                    </option>
                                  )
                                })}
                            </select>
                          </>}
                          {this.state.movementsType &&
                            this.state.movementsType.length == 1 &&
                            <>
                            <select
                              disabled
                              defaultValue={"default"}
                              className="custome-drop-down"
                              value={this.state.operation.idTipoMovimento}
                              onChange={(e) => this.handleChange(e)}
                              name="IDTipoMovimento"
                            >
                              {/* <option disabled value="default">
                                Selecione o movimento{" "}
                              </option> */}
                              {this.state.movementsType &&
                                this.state.movementsType.length > 0 &&
                                this.state.movementsType.map((_row, _indx) => {
                                  return (
                                    <option key={_indx} value={_row.idTipoMovimento}>
                                      {_row.codTipoMovimento} - {_row.tipoMovimento}
                                    </option>
                                  )
                                })}
                            </select>
                          </>}
                        </div>
                      </div>
                    </>}
                  </div>
                </>
              )}
              {this.state.isMovementSelected > 0 && this.state.needEntidade == false && this.state.needTipoContaDestino == false && this.state.lotas == false && this.state.desclassificacao == false && this.state.destilacao == false && this.state.constituicaoLotes == false && this.state.certProcedencia == false && (
                <>
                  <p>Detalhes do movimento</p>
                  <div className="right-section">
                    <div className="bg-white middle p20" id="parcel">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="input-box active-grey">
                            <Input
                              style={{
                                width: "100%",
                              }}
                              className="input-1"
                              name="Descricao"
                              placeholder="Descrição da operação"
                              label="Descrição"
                              onChange={(e) => this.handleChange(e)}
                            />
                            {
                            this.state.mandatoryFieldsMissing && !this.state.operation["Descricao"] &&  
                            <span className="text-danger" style={{marginTop: "-10px"}}>Campo obrigatório</span>
                            }
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="input-box active-grey mt20">
                            {/* <label className="input-label z-index-9" >Data última vistoria</label> */}
                            {this.handleDatePicker()}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="input-box active-grey">
                            <Input
                              type="number"
                              style={{
                                width: "100%",
                              }}
                              className="input-1"
                              name="ValorOperacao"
                              label="Quantidade (Litros)"
                              onChange={(e) => this.handleChange(e)}
                            />
                            {
                            this.state.mandatoryFieldsMissing && !this.state.operation["ValorOperacao"] &&  
                            <span className="text-danger" style={{marginTop: "-10px"}}>Campo obrigatório</span>
                            }
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <span className="pr-3">Detalhes da operação : </span>
                          <br></br>
                          <span className="pr-3">
                            Será realizada a operação (
                            {(this.state.selectedMovemment &&
                              this.state.selectedMovemment[0].tipoMovimento) ||
                              "Movement Description"}
                            ) com a quantidade, em litros, de:{" "}
                            {services.money.format(operation.ValorOperacao) ||
                              "<< Operation Value >>"}
                            . Confirma a operação?{" "}
                          </span>
                        </div>
                        <div className="col-md-12 mt-4">
                          <button
                            className="k-button k-primary btn-ivdp-primary btn-sm"
                            type="submit"
                            onClick={this.handleSubmit}
                          >
                            Efetuar Operação
                          </button>
                          <button
                            className="k-button mr-2 k-primary btn-ivdp-secondary btn-theme remoove ml-2 text-danger"
                            onClick={() => this.handleCancel()}
                          >
                            Cancelar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {this.state.isMovementSelected > 0 && this.state.needEntidade == true && this.state.needTipoContaDestino == false && this.state.lotas == false && this.state.desclassificacao == false && this.state.destilacao == false && this.state.constituicaoLotes == false && this.state.certProcedencia == false && (
                <>
                  <p>Detalhes do movimento</p>
                  <div className="right-section">
                    <div className="bg-white middle p20" id="parcel">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="input-box active-grey">
                            <Input
                              style={{
                                width: "100%",
                              }}
                              className="input-1"
                              name="Descricao"
                              placeholder="Descrição da operação"
                              label="Descrição"
                              onChange={(e) => this.handleChange(e)}
                            />
                            {
                            this.state.mandatoryFieldsMissing && !this.state.operation["Descricao"] &&  
                            <span className="text-danger" style={{marginTop: "-10px"}}>Campo obrigatório</span>
                            }
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-3">
                          <div className="input-box active-grey mt23">
                            {/* <label className="input-label z-index-9" >Data última vistoria</label> */}
                            {this.handleDatePicker()}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input-box active-grey">
                            <Input
                              type="number"
                              style={{
                                width: "100%",
                              }}
                              className="input-1"
                              name="ValorOperacao"
                              label="Quantidade (Litros)"
                              onChange={(e) => this.handleChange(e)}
                            />
                            {
                            this.state.mandatoryFieldsMissing && !this.state.operation["ValorOperacao"] &&  
                            <span className="text-danger" style={{marginTop: "-10px"}}>Campo obrigatório</span>
                            }
                          </div>
                        </div>
                        
                        <div className="col-md-5">
                          
                          <div className="input-box active-grey">
                            <span>Entidade destino</span>
                            <Select
                              showSearch
                              onSearch={(e) => this.searchEntidade(e)}
                              optionFilterProp="children"
                              // maxTagTextLength={ 3 }
                              placeholder="Selecione a entidade destino"
                              className="mov-Ent-Select"
                              //value={this.state.data.idTipoFormulario}
                              onChange={(e) => this.handleChangeEntidade(e)}
                              style={{ width: "100%" }}
                            >
                              <Option disabled >Selecione a entidade destino</Option>
                              {(this.state.entidades && !!this.state.entidades.length) && this.state.entidades.map((item, index) => (
                                <Option key={index} value={item.codEntidade}>{item.nif} - {item.nome}</Option>
                              ))}
                            </Select>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <span className="pr-3">Detalhes da operação : </span>
                          <br></br>
                          <span className="pr-3">
                            Será realizada a operação (
                            {(this.state.selectedMovemment &&
                              this.state.selectedMovemment[0].tipoMovimento) ||
                              "Movement Description"}
                            ) com a quantidade, em litros, de:{" "}
                            {services.money.format(operation.ValorOperacao) ||
                              "<< Operation Value >>"}
                            . Confirma a operação?{" "}
                          </span>
                        </div>
                        <div className="col-md-12 mt-4">
                          <button
                            className="k-button k-primary btn-ivdp-primary btn-sm"
                            type="submit"
                            onClick={this.handleSubmit}
                          >
                            Efetuar Operação
                          </button>
                          <button
                            className="k-button mr-2 k-primary btn-ivdp-secondary btn-theme remoove ml-2 text-danger"
                            onClick={() => this.handleCancel()}
                          >
                            Cancelar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {this.state.isMovementSelected > 0 && this.state.needEntidade == false && this.state.needTipoContaDestino == true && this.state.lotas == false && this.state.desclassificacao == false && this.state.destilacao == false && this.state.constituicaoLotes == false && this.state.certProcedencia == false && (
                <>
                  <p>Detalhes do movimento</p>
                  <div className="right-section">
                    <div className="bg-white middle p20" id="parcel">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="input-box active-grey">
                            <Input
                              style={{
                                width: "100%",
                              }}
                              className="input-1"
                              name="Descricao"
                              placeholder="Descrição da operação"
                              label="Descrição"
                              onChange={(e) => this.handleChange(e)}
                            />
                            {
                            this.state.mandatoryFieldsMissing && !this.state.operation["Descricao"] &&  
                            <span className="text-danger" style={{marginTop: "-10px"}}>Campo obrigatório</span>
                            }
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-3">
                          <div className="input-box active-grey mt23">
                            {/* <label className="input-label z-index-9" >Data última vistoria</label> */}
                            {this.handleDatePicker()}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input-box active-grey">
                            <Input
                              type="number"
                              style={{
                                width: "100%",
                              }}
                              className="input-1"
                              name="ValorOperacao"
                              label="Quantidade (Litros)"
                              onChange={(e) => this.handleChange(e)}
                            />
                            {
                            this.state.mandatoryFieldsMissing && !this.state.operation["ValorOperacao"] &&  
                            <span className="text-danger" style={{marginTop: "-10px"}}>Campo obrigatório</span>
                            }
                          </div>
                        </div>
                        
                        <div className="col-md-5">
                          
                          <div className="input-box active-grey">
                            <span>Tipo de Conta Destino</span>
                            <Select
                              optionFilterProp="children"
                              // maxTagTextLength={ 3 }
                              placeholder="Selecione o tipo de conta destino"
                              className="mov-Ent-Select"
                              //value={this.state.data.idTipoFormulario}
                              onChange={(e) => this.handleChangeTipoContaDestino(e)}
                              style={{ width: "100%" }}
                            >
                              <Option disabled >Selecione o tipo de conta destino</Option>
                              {(this.state.tiposConta && !!this.state.tiposConta.length) && this.state.tiposConta.map((item, index) => (
                                <Option key={index} value={item.idTipoConta}>{item.descricao}</Option>
                              ))}
                            </Select>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <span className="pr-3">Detalhes da operação : </span>
                          <br></br>
                          <span className="pr-3">
                            Será realizada a operação (
                            {(this.state.selectedMovemment &&
                              this.state.selectedMovemment[0].tipoMovimento) ||
                              "Movement Description"}
                            ) com a quantidade, em litros, de:{" "}
                            {services.money.format(operation.ValorOperacao) ||
                              "<< Operation Value >>"}
                            . Confirma a operação?{" "}
                          </span>
                        </div>
                        <div className="col-md-12 mt-4">
                          <button
                            className="k-button k-primary btn-ivdp-primary btn-sm"
                            type="submit"
                            onClick={this.handleSubmit}
                          >
                            Efetuar Operação
                          </button>
                          <button
                            className="k-button mr-2 k-primary btn-ivdp-secondary btn-theme remoove ml-2 text-danger"
                            onClick={() => this.handleCancel()}
                          >
                            Cancelar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {this.state.isMovementSelected > 0 && this.state.lotas == true && (
                <>
                  <p>Detalhes do movimento</p>
                  <div className="right-section">
                    <div className="bg-white middle p20" id="parcel">
                      <div className="row">
                        <div className="col-md-4">
                          <div className="input-box active-grey">
                            <span>Produto Destino</span>
                            <Select
                              optionFilterProp="children"
                              // maxTagTextLength={ 3 }
                              placeholder="Selecione o produto destino"
                              className="mov-Ent-Select"
                              //value={this.state.data.idTipoFormulario}
                              onChange={(e) => this.handleChangeProdutoDestinoLotas(e)}
                              style={{ width: "100%" }}
                            >
                              <Option disabled >Selecione o produto destino</Option>
                              {(this.state.lotasProdutoDestino && !!this.state.lotasProdutoDestino.length) && this.state.lotasProdutoDestino.map((item, index) => (
                                <Option key={index} value={item.idProdutoDestino}>{item.produto}</Option>
                              ))}
                            </Select>
                          </div>
                        </div>
                        <div className="col-md-8">
                          <div className="input-box active-grey">
                            <span>Conta Destino</span>
                            <Select
                              optionFilterProp="children"
                              // maxTagTextLength={ 3 }
                              placeholder="Selecione a conta destino"
                              className="mov-Ent-Select"
                              //value={this.state.data.idTipoFormulario}
                              onChange={(e) => this.handleChangeContaDestino(e)}
                              style={{ width: "100%" }}
                            >
                              <Option disabled >Selecione a conta destino</Option>
                              {(this.state.lotasContasDestino && !!this.state.lotasContasDestino.length) && this.state.lotasContasDestino.map((item, index) => (
                                <Option key={index} value={item.idContaCorrente}>{item.produto} - {item.tipoConta} - {item.cor} - {item.anoProduto} - {item.estado} - {services.money.format(item.saldo)} (L)</Option>
                              ))}
                            </Select>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="input-box active-grey">
                            <Input
                              style={{
                                width: "100%",
                              }}
                              className="input-1"
                              name="Descricao"
                              placeholder="Descrição da operação"
                              label="Descrição"
                              onChange={(e) => this.handleChange(e)}
                            />
                            {
                            this.state.mandatoryFieldsMissing && !this.state.operation["Descricao"] &&  
                            <span className="text-danger" style={{marginTop: "-10px"}}>Campo obrigatório</span>
                            }
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="input-box active-grey mt23">
                            {/* <label className="input-label z-index-9" >Data última vistoria</label> */}
                            {this.handleDatePicker()}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="input-box active-grey">
                            <Input
                              type="number"
                              style={{
                                width: "100%",
                              }}
                              className="input-1"
                              name="ValorOperacao"
                              label="Quantidade (Litros)"
                              onChange={(e) => this.handleChange(e)}
                            />
                            {
                            this.state.mandatoryFieldsMissing && !this.state.operation["ValorOperacao"] &&  
                            <span className="text-danger" style={{marginTop: "-10px"}}>Campo obrigatório</span>
                            }
                          </div>
                        </div>
                        
                        
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <span className="pr-3">Detalhes da operação : </span>
                          <br></br>
                          <span className="pr-3">
                            Será realizada a operação (
                            {(this.state.selectedMovemment &&
                              this.state.selectedMovemment[0].tipoMovimento) ||
                              "Movement Description"}
                            ) com a quantidade, em litros, de:{" "}
                            {services.money.format(operation.ValorOperacao) ||
                              "<< Operation Value >>"}
                            . Confirma a operação?{" "}
                          </span>
                        </div>
                        <div className="col-md-12 mt-4">
                          <button
                            className="k-button k-primary btn-ivdp-primary btn-sm"
                            type="submit"
                            onClick={this.handleSubmit}
                          >
                            Efetuar Operação
                          </button>
                          <button
                            className="k-button mr-2 k-primary btn-ivdp-secondary btn-theme remoove ml-2 text-danger"
                            onClick={() => this.handleCancel()}
                          >
                            Cancelar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {this.state.isMovementSelected > 0 && this.state.desclassificacao == true && (
                <>
                  <p>Detalhes do movimento</p>
                  <div className="right-section">
                    <div className="bg-white middle p20" id="parcel">
                      <div className="row">
                        <div className="col-md-4">
                          <div className="input-box active-grey">
                            <span>Produto Destino</span>
                            <Select
                              optionFilterProp="children"
                              // maxTagTextLength={ 3 }
                              placeholder="Selecione o produto destino"
                              className="mov-Ent-Select"
                              //value={this.state.data.idTipoFormulario}
                              onChange={(e) => this.handleChangeProdutoDestinoDesc(e)}
                              style={{ width: "100%" }}
                            >
                              <Option disabled >Selecione o produto destino</Option>
                              {(this.state.descProdutoDestino && !!this.state.descProdutoDestino.length) && this.state.descProdutoDestino.map((item, index) => (
                                <Option key={index} value={item.idProdutoDestino}>{item.produto}</Option>
                              ))}
                            </Select>
                          </div>
                        </div>
                        <div className="col-md-2" id="manterAnoAlign">
                          <div className="custom-control custom-switch">
                              
                            <input
                              type="checkbox"
                              //name={item.name}
                              defaultChecked={this.state.operation.ManterAno}
                              onChange={(e) => this.handleChangeManterAno(e.target.checked)}
                              className="custom-control-input"
                              id="desc-manter-ano"
                            />
                              
                            <label className="custom-control-label" htmlFor="desc-manter-ano">Manter Ano</label>
                          </div>
                        </div>
                        {this.state.descGarrafeira && <>
                        <div className="col-md-3" id="GarrafeiraAlign">
                        <span>Selecione menção a acrescentar</span>
                          <div className="box-switch-mencoes"> 
                          <div className="custom-control custom-switch">
                          <input
                              type="checkbox"
                              //name={item.name}
                              // defaultChecked={this.state.operation.ManterAno}
                              onChange={(e) => this.handleChangeGarrafeira(e.target.checked,this.state.descGarrafeira.idContaCorrenteMencaoComplementar)}
                              
                              className="custom-control-input"
                              
                              id={this.state.descGarrafeira.idContaCorrenteMencaoComplementar}
                            />
                              
                              <label className="custom-control-label" htmlFor={this.state.descGarrafeira.idContaCorrenteMencaoComplementar}>{this.state.descGarrafeira.mencaoComplementar}</label>
                            </div>  
                          </div>
                        </div>
                        </>}
                        <div className="col-md-3" id="MencoesAlign">
                        <span>Selecione as menções a manter</span>
                          <div className="box-switch-mencoes"> 
                          {((this.state.descMencoesComp.mencoesCasta && this.state.descMencoesComp.mencoesCasta.length == 0) && (this.state.descMencoesComp.mencoesQuinta && this.state.descMencoesComp.mencoesQuinta.length == 0) && (this.state.descMencoesComp.outrasMencoes && this.state.descMencoesComp.outrasMencoes.length == 0)) && <>
                            <div>
                              <p>Não existem menções complementares para seleção</p>
                            </div>
                          </>}
                          {this.state.descMencoesComp.mencoesCasta &&
                            this.state.descMencoesComp.mencoesCasta.length > 0 &&
                            this.state.descMencoesComp.mencoesCasta.map((item, index) => (
                              <div className="custom-control custom-switch">
                                <input
                                  type="checkbox"
                                  name={item.designacao}
                                  onChange={(e) => this.handleChangeMencoes(e.target.checked, item.idContaCorrenteMencaoComplementar)}
                                  className="custom-control-input"
                                  id={item.idContaCorrenteMencaoComplementar}
                                />
                                <label className="custom-control-label" htmlFor={item.idContaCorrenteMencaoComplementar}>{ item.designacao }</label>
                              </div>
                            ))
                          }
                          {this.state.descMencoesComp.mencoesQuinta &&
                            this.state.descMencoesComp.mencoesQuinta.length > 0 &&
                            this.state.descMencoesComp.mencoesQuinta.map((item, index) => (
                              <div className="custom-control custom-switch">
                                <input
                                  type="checkbox"
                                  name={item.designacao}
                                  onChange={(e) => this.handleChangeMencoes(e.target.checked, item.idContaCorrenteMencaoComplementar)}
                                  className="custom-control-input"
                                  id={item.idContaCorrenteMencaoComplementar}
                                />
                                <label className="custom-control-label" htmlFor={item.idContaCorrenteMencaoComplementar}>{ item.designacao }</label>
                              </div>
                            ))
                          }
                          {this.state.descMencoesComp.outrasMencoes &&
                            this.state.descMencoesComp.outrasMencoes.length > 0 &&
                            this.state.descMencoesComp.outrasMencoes.map((item, index) => (
                              <div className="custom-control custom-switch">
                                <input
                                  type="checkbox"
                                  name={item.mencaoComplementar}
                                  onChange={(e) => this.handleChangeMencoes(e.target.checked, item.idContaCorrenteMencaoComplementar)}
                                  className="custom-control-input"
                                  id={item.idContaCorrenteMencaoComplementar}
                                />
                                <label className="custom-control-label" htmlFor={item.idContaCorrenteMencaoComplementar}>{ item.mencaoComplementar }</label>
                              </div>
                            ))
                          }
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="input-box active-grey">
                            <Input
                              style={{
                                width: "100%",
                              }}
                              className="input-1"
                              name="Descricao"
                              placeholder="Descrição da operação"
                              label="Descrição"
                              onChange={(e) => this.handleChange(e)}
                            />
                            {
                            this.state.mandatoryFieldsMissing && !this.state.operation["Descricao"] &&  
                            <span className="text-danger" style={{marginTop: "-10px"}}>Campo obrigatório</span>
                            }
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="input-box active-grey mt23">
                            {/* <label className="input-label z-index-9" >Data última vistoria</label> */}
                            {this.handleDatePicker()}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="input-box active-grey">
                            <Input
                              type="number"
                              style={{
                                width: "100%",
                              }}
                              className="input-1"
                              name="ValorOperacao"
                              label="Quantidade (Litros)"
                              onChange={(e) => this.handleChange(e)}
                            />
                            {
                            this.state.mandatoryFieldsMissing && !this.state.operation["ValorOperacao"] &&  
                            <span className="text-danger" style={{marginTop: "-10px"}}>Campo obrigatório</span>
                            }
                          </div>
                        </div>
                        
                        
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <span className="pr-3">Detalhes da operação : </span>
                          <br></br>
                          <span className="pr-3">
                            Será realizada a operação (
                            {(this.state.selectedMovemment &&
                              this.state.selectedMovemment[0].tipoMovimento) ||
                              "Movement Description"}
                            ) com a quantidade, em litros, de:{" "}
                            {services.money.format(operation.ValorOperacao) ||
                              "<< Operation Value >>"}
                            . Confirma a operação?{" "}
                          </span>
                        </div>
                        <div className="col-md-12 mt-4">
                          <button
                            className="k-button k-primary btn-ivdp-primary btn-sm"
                            type="submit"
                            onClick={this.handleSubmit}
                          >
                            Efetuar Operação
                          </button>
                          <button
                            className="k-button mr-2 k-primary btn-ivdp-secondary btn-theme remoove ml-2 text-danger"
                            onClick={() => this.handleCancel()}
                          >
                            Cancelar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {this.state.isMovementSelected > 0 && this.state.destilacao == true && (
                <>
                  <p>Detalhes do movimento</p>
                  <div className="right-section">
                    <div className="bg-white middle p20" id="parcel">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="input-box active-grey">
                            <span>Produto Destino</span>
                            <Select
                              optionFilterProp="children"
                              // maxTagTextLength={ 3 }
                              placeholder="Selecione o produto destino"
                              className="mov-Ent-Select"
                              //value={this.state.data.idTipoFormulario}
                              onChange={(e) => this.handleChangeProdutoDestinoDestilacao(e)}
                              style={{ width: "100%" }}
                            >
                              <Option disabled >Selecione o produto destino</Option>
                              {(this.state.destilacaoProdutoDestino && !!this.state.destilacaoProdutoDestino.length) && this.state.destilacaoProdutoDestino.map((item, index) => (
                                <Option key={index} value={item.idProdutoDestino}>{item.produto}</Option>
                              ))}
                            </Select>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="input-box active-grey d-none" id="NumEDADiv">
                            <Input
                              style={{
                                width: "100%",
                              }}
                              className="input-1"
                              name="NumeroEDA"
                              id="NumeroEDA"
                              placeholder="Número EDA"
                              label="Número EDA"
                              onChange={(e) => this.handleChangeNumEDA(e)}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="input-box active-grey">
                            <Input
                              style={{
                                width: "100%",
                              }}
                              className="input-1"
                              name="Descricao"
                              placeholder="Descrição da operação"
                              label="Descrição"
                              onChange={(e) => this.handleChange(e)}
                            />
                            {
                            this.state.mandatoryFieldsMissing && !this.state.operation["Descricao"] &&  
                            <span className="text-danger" style={{marginTop: "-10px"}}>Campo obrigatório</span>
                            }
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="input-box active-grey mt23">
                            {/* <label className="input-label z-index-9" >Data última vistoria</label> */}
                            {this.handleDatePicker()}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="input-box active-grey">
                            <Input
                              type="number"
                              style={{
                                width: "100%",
                              }}
                              className="input-1"
                              name="ValorOperacao"
                              label="Quantidade (Litros)"
                              onChange={(e) => this.handleChange(e)}
                            />
                            {
                            this.state.mandatoryFieldsMissing && !this.state.operation["ValorOperacao"] &&  
                            <span className="text-danger" style={{marginTop: "-10px"}}>Campo obrigatório</span>
                            }
                          </div>
                        </div>
                        
                        
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <span className="pr-3">Detalhes da operação : </span>
                          <br></br>
                          <span className="pr-3">
                            Será realizada a operação (
                            {(this.state.selectedMovemment &&
                              this.state.selectedMovemment[0].tipoMovimento) ||
                              "Movement Description"}
                            ) com a quantidade, em litros, de:{" "}
                            {services.money.format(operation.ValorOperacao) ||
                              "<< Operation Value >>"}
                            . Confirma a operação?{" "}
                          </span>
                        </div>
                        <div className="col-md-12 mt-4">
                          <button
                            className="k-button k-primary btn-ivdp-primary btn-sm"
                            type="submit"
                            onClick={this.handleSubmit}
                          >
                            Efetuar Operação
                          </button>
                          <button
                            className="k-button mr-2 k-primary btn-ivdp-secondary btn-theme remoove ml-2 text-danger"
                            onClick={() => this.handleCancel()}
                          >
                            Cancelar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {this.state.isMovementSelected > 0 && this.state.constituicaoLotes == true && (
                <>
                  <p>Detalhes do movimento</p>
                  <div className="right-section">
                    <div className="bg-white middle p20" id="parcel">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="input-box active-grey">
                            <span>Conta Destino</span>
                            <Select
                              optionFilterProp="children"
                              // maxTagTextLength={ 3 }
                              placeholder="Selecione a conta destino"
                              className="mov-Ent-Select"
                              //value={this.state.data.idTipoFormulario}
                              onChange={(e) => this.handleChangeContaDestino(e)}
                              style={{ width: "100%" }}
                            >
                              <Option disabled >Selecione a conta destino</Option>
                              {(this.state.constLotesContasDestino && !!this.state.constLotesContasDestino.length) && this.state.constLotesContasDestino.map((item, index) => (
                                <Option key={index} value={item.idContaCorrente}>{item.produto} - {item.tipoConta} - {item.cor} - {item.anoProduto} - {item.estado} - {services.money.format(item.saldo)} (L)</Option>
                              ))}
                            </Select>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="input-box active-grey">
                            <Input
                              style={{
                                width: "100%",
                              }}
                              className="input-1"
                              name="Descricao"
                              placeholder="Descrição da operação"
                              label="Descrição"
                              onChange={(e) => this.handleChange(e)}
                            />
                            {
                            this.state.mandatoryFieldsMissing && !this.state.operation["Descricao"] &&  
                            <span className="text-danger" style={{marginTop: "-10px"}}>Campo obrigatório</span>
                            }
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="input-box active-grey mt23">
                            {/* <label className="input-label z-index-9" >Data última vistoria</label> */}
                            {this.handleDatePicker()}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="input-box active-grey">
                            <Input
                              type="number"
                              style={{
                                width: "100%",
                              }}
                              className="input-1"
                              name="ValorOperacao"
                              label="Quantidade (Litros)"
                              onChange={(e) => this.handleChange(e)}
                            />
                            {
                            this.state.mandatoryFieldsMissing && !this.state.operation["ValorOperacao"] &&  
                            <span className="text-danger" style={{marginTop: "-10px"}}>Campo obrigatório</span>
                            }
                          </div>
                        </div>
                        
                        
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <span className="pr-3">Detalhes da operação : </span>
                          <br></br>
                          <span className="pr-3">
                            Será realizada a operação (
                            {(this.state.selectedMovemment &&
                              this.state.selectedMovemment[0].tipoMovimento) ||
                              "Movement Description"}
                            ) com a quantidade, em litros, de:{" "}
                            {services.money.format(operation.ValorOperacao) ||
                              "<< Operation Value >>"}
                            . Confirma a operação?{" "}
                          </span>
                        </div>
                        <div className="col-md-12 mt-4">
                          <button
                            className="k-button k-primary btn-ivdp-primary btn-sm"
                            type="submit"
                            onClick={this.handleSubmit}
                          >
                            Efetuar Operação
                          </button>
                          <button
                            className="k-button mr-2 k-primary btn-ivdp-secondary btn-theme remoove ml-2 text-danger"
                            onClick={() => this.handleCancel()}
                          >
                            Cancelar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {this.state.isMovementSelected > 0 && this.state.certProcedencia == true && (
                <>
                  <p>Detalhes do movimento</p>
                  <div className="right-section">
                    <div className="bg-white middle p20" id="parcel">
                      <div className="row">
                        <div className="col-md-4">
                          <div className="input-box active-grey">
                            <span>Local de Armazenagem</span>
                            <Select
                              optionFilterProp="children"
                              // maxTagTextLength={ 3 }
                              placeholder="Selecione o local de armazenagem"
                              className="mov-Ent-Select"
                              //value={this.state.data.idTipoFormulario}
                              onChange={(e) => this.handleChangeLocalArmazCertProc(e)}
                              style={{ width: "100%" }}
                            >
                              <Option disabled >Selecione o local de armazenagem</Option>
                              {(this.state.certProcLocalArmaz && !!this.state.certProcLocalArmaz.length) && this.state.certProcLocalArmaz.map((item, index) => (
                                <Option key={index} value={item.idLocalArmazenagem}>{item.descricao}</Option>
                              ))}
                            </Select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input-box active-grey">
                            <span>Instalação Vínica Destino</span>
                            <Select
                              optionFilterProp="children"
                              // maxTagTextLength={ 3 }
                              placeholder="Selecione a instalação vínica de destino"
                              className="mov-Ent-Select"
                              //value={this.state.data.idTipoFormulario}
                              onChange={(e) => this.handleChangeIVDest(e)}
                              style={{ width: "100%" }}
                            >
                              <Option disabled >Selecione a instalação vínica de destino</Option>
                              {(this.state.certProcIVDest && !!this.state.certProcIVDest.length) && this.state.certProcIVDest.map((item, index) => (
                                <Option key={index} value={item.idInstalacaoVinica}>{item.instalacaoVinica}</Option>
                              ))}
                            </Select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input-box active-grey" id="selos-seguranca">
                            <span>Selos de Segurança</span>
                            <Select
                              mode="multiple"
                              allowClear
                              optionFilterProp="children"
                              // maxTagTextLength={ 3 }
                              placeholder="Selecione os selos de segurança"
                              //className="mov-Ent-Select"
                              //value={this.state.data.idTipoFormulario}
                              onChange={(e) => this.handleChangeCertProcSelosSeg(e)}
                              style={{ width: "100%" }}
                            >
                              <Option disabled >Selecione os selos de segurança</Option>
                              {(this.state.certProcSelosSeg && !!this.state.certProcSelosSeg.length) && this.state.certProcSelosSeg.map((item, index) => (
                                <Option key={index} value={item.idSelosSeguranca}>{item.numeroSelo}</Option>
                              ))}
                            </Select>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="input-box active-grey">
                            <Input
                              style={{
                                width: "100%",
                              }}
                              className="input-1"
                              name="LoteCertProc"
                              placeholder="Lote"
                              label="Lote"
                              onChange={(e) => this.handleChangeLoteCertProc(e)}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input-box active-grey">
                            <Input
                              style={{
                                width: "100%",
                              }}
                              className="input-1"
                              name="NumATCertProc"
                              placeholder="Referência de documento de transporte"
                              label="Referência de documento de transporte"
                              onChange={(e) => this.handleChangeNumEDA(e)}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input-box active-grey" id="certNif">
                            <span>Entidade destino</span>
                            <Select
                              showSearch
                              onSearch={(e) => this.searchEntidade(e)}
                              optionFilterProp="children"
                              // maxTagTextLength={ 3 }
                              placeholder="Selecione a entidade destino"
                              className="mov-Ent-Select"
                              //value={this.state.data.idTipoFormulario}
                              onChange={(e) => this.handleChangeEntidade(e)}
                              style={{ width: "100%" }}
                            >
                              <Option disabled >Selecione a entidade destino</Option>
                              {(this.state.entidades && !!this.state.entidades.length) && this.state.entidades.map((item, index) => (
                                <Option key={index} value={item.codEntidade}>{item.nif} - {item.nome}</Option>
                              ))}
                            </Select>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        {/* <div className="col-md-4">
                          <div className="input-box active-grey">
                            <Input
                              style={{
                                width: "100%",
                              }}
                              className="input-1"
                              name="Descricao"
                              placeholder="Morada de Expedição"
                              label="Morada"
                              onChange={(e) => this.handleChangeMoradaCertProc(e)}
                            />
                          </div>
                        </div> */}
                        <div className="col-md-4">
                          <div className="input-box active-grey mt23">
                            {/* <label className="input-label z-index-9" >Data última vistoria</label> */}
                            {this.handleDatePickerExpedicao()}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input-box active-grey">
                            <Input
                              style={{
                                width: "100%",
                              }}
                              className="input-1"
                              name="Descricao"
                              placeholder="Matrícula (Veículo | Atrelado)"
                              label="Matrícula"
                              onChange={(e) => this.handleChangeMatriculaCertProc(e)}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="input-box active-grey">
                            <Input
                              style={{
                                width: "100%",
                              }}
                              className="input-1"
                              name="Descricao"
                              placeholder="Descrição da operação"
                              label="Descrição"
                              onChange={(e) => this.handleChange(e)}
                            />
                            {
                            this.state.mandatoryFieldsMissing && !this.state.operation["Descricao"] &&  
                            <span className="text-danger" style={{marginTop: "-10px"}}>Campo obrigatório</span>
                            }
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="input-box active-grey mt23">
                            {/* <label className="input-label z-index-9" >Data última vistoria</label> */}
                            {this.handleDatePicker()}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="input-box active-grey">
                            <Input
                              type="number"
                              style={{
                                width: "100%",
                              }}
                              className="input-1"
                              name="ValorOperacao"
                              label="Quantidade (Litros)"
                              onChange={(e) => this.handleChange(e)}
                            />
                            {
                            this.state.mandatoryFieldsMissing && !this.state.operation["ValorOperacao"] &&  
                            <span className="text-danger" style={{marginTop: "-10px"}}>Campo obrigatório</span>
                            }
                          </div>
                        </div>
                        
                        
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <span className="pr-3">Detalhes da operação : </span>
                          <br></br>
                          <span className="pr-3">
                            Será realizada a operação (
                            {(this.state.selectedMovemment &&
                              this.state.selectedMovemment[0].tipoMovimento) ||
                              "Movement Description"}
                            ) com a quantidade, em litros, de:{" "}
                            {services.money.format(operation.ValorOperacao) ||
                              "<< Operation Value >>"}
                            . Confirma a operação?{" "}
                          </span>
                        </div>
                        <div className="col-md-12 mt-4">
                          <button
                            className="k-button k-primary btn-ivdp-primary btn-sm"
                            type="submit"
                            onClick={this.handleSubmit}
                          >
                            Efetuar Operação
                          </button>
                          <button
                            className="k-button mr-2 k-primary btn-ivdp-secondary btn-theme remoove ml-2 text-danger"
                            onClick={() => this.handleCancel()}
                          >
                            Cancelar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {/* </form> */}
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default AccountMovement
